import(/* webpackMode: "eager" */ "/home/ubuntu/website/node_modules/next/dist/client/image-component.js");
